@if (categoriesData()) {
  <div class="mega-menu">
    <!-- product category -->
    <ul class="mega-menu__categories">
      @for (category of categoriesData(); track category.title) {
        <li
          class="category-item"
          [ngClass]="{
            'mega-menu__categories--active':
              category._id === currentProductCategory?._id &&
              category?.children?.length !== 0,
            'mega-menu__categories--disabled': category?.products_count === 0,
          }"
          (mouseover)="onSelectCategory(category)"
          (click)="closeMegaMenu()">
          <a
            class="category-item__link"
            [routerLink]="['products']"
            [queryParams]="{
              category_type_id: category?._id,
              category_id: null,
              sub_category_id: null,
            }">
            <!-- category icon -->
            <!-- @if (productType.icon) {
            <img
              class="category-item__icon"
              [ngSrc]="productType.icon"
              width="20"
              height="20"
              [alt]="productType.category" />
          } -->
            <!-- category text -->
            <span class="category-item__text">
              {{ category?.title | translateData }}
            </span>
          </a>
        </li>
      }
    </ul>

    <!-- product type -->
    <ul class="mega-menu__sub-categories">
      @for (type of productTypes; track type?._id) {
        <li
          class="category-item"
          [ngClass]="{
            'mega-menu__categories--active':
              type?._id === currentProductType?._id &&
              type?.children?.length !== 0,
            'before:!hidden': false,
            'mega-menu__categories--disabled': type?.products_count === 0,
          }"
          (mouseover)="onSelectSubCategory(type)"
          (click)="closeMegaMenu()">
          <span
            class="break-point"
            [ngClass]="{
              'break-point--active': type?._id === currentProductType?._id,
            }"></span>
          <a
            class="category-item__link"
            [routerLink]="['products']"
            [queryParams]="{
              category_type_id: currentProductCategory?._id,
              category_id: type._id,
              sub_category_id: null,
            }"
            queryParamsHandling="merge">
            {{ type?.title | translateData }}
          </a>
        </li>
      }
    </ul>

    <!-- products categories -->
    <div class="mega-menu__products-container custom-scrollbar">
      <ul class="mega-menu__products-types">
        @for (productName of productNames; track productName?._id) {
          <li
            class="mega-menu__products-types-item"
            [ngClass]="{
              'mega-menu__categories--disabled':
                productName?.products_count === 0,
            }"
            (click)="closeMegaMenu()">
            <a
              [routerLink]="['products']"
              [queryParams]="{
                category_type_id: currentProductCategory?._id,
                category_id: currentProductType?._id,
                sub_category_id: productName?._id,
              }"
              queryParamsHandling="merge">
              {{ productName?.title | translateData }}
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
} @else {
  <section>
    <pwj-mega-menu-skeleton></pwj-mega-menu-skeleton>
  </section>
}
